/**
* 系统管理  权限管理
*/
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>管理员管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="listData" highlight-current-row
                  v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column sortable prop="id" label="ID" max-width="50"></el-table-column>
            <el-table-column prop="phone" label="联系电话"></el-table-column>
            <el-table-column prop="real_name" label="真实姓名"></el-table-column>
            <el-table-column prop="groups" label="用户组"></el-table-column>
            <el-table-column align="center" prop="is_lock" label="是否锁定" min-width="50">
                <template slot-scope="scope">
                    <span v-if="scope.row.is_lock == 1">是</span>
                    <span v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteUser(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="登录账号" prop="phone">
                    <el-input size="small" v-model="editForm.phone" auto-complete="off"
                              placeholder="登录账号"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名" prop="real_name">
                    <el-input size="small" v-model="editForm.real_name" auto-complete="off"
                              placeholder="真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="是否锁定" prop="is_lock">
                    <el-radio label="1" v-model="editForm.is_lock">是</el-radio>
                    <el-radio label="0" v-model="editForm.is_lock">否</el-radio>
                </el-form-item>
                <!--<el-form-item label="选择分组" prop="group_id">
                    <el-checkbox-group v-model="editForm.group_id">
                        <el-checkbox :label="item.id.toString()" v-for="item in userGroupData">{{item.title}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {manager, saveManager, userGroup} from '../../api/userMG'
    import Pagination from '../../components/Pagination'

    export default {
        data() {
            return {
                nshow: true, //switch开启
                fshow: false, //switch关闭
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                title: '添加',
                radio: 1,
                editForm: {
                    id: '',
                    phone: '',
                    real_name: '',
                    is_lock: 0,
                    group_id: [],
                },
                // rules表单验证
                rules: {
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'}
                    ],
                    real_name: [
                        {required: true, message: '请输入真实姓名', trigger: 'blur'}
                    ],
                    group_id: [
                        {required: true, message: '请选择分组', trigger: 'blur'}
                    ],
                    is_lock: [
                        {required: true, message: '请选择是否锁定', trigger: 'blur'}
                    ],
                },
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10,
                },
                // 选择数据
                selectdata: [],
                userGroupData: [],
                userparm: [], //搜索权限
                listData: [], //用户数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                }
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 数据发生改变
         */
        watch: {},
        /**
         * 创建完毕
         */
        created() {
            this.loading = true
            this.getdata(this.formInline)
            this.getUserGroup()
        },
        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            // 获取数据方法
            getdata(parameter) {
                // 模拟数据
                this.loading = false
                manager().then(res => {
                    this.listData = res.data
                })
                // 分页赋值
                this.pageparm.currentPage = this.formInline.page
                this.pageparm.pageSize = this.formInline.limit
            },
            getUserGroup() {
                userGroup().then(res => {
                    this.userGroupData = res.data;
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.page = parm.currentPage
                this.formInline.limit = parm.pageSize
                this.getdata(this.formInline)
            },
            //显示编辑界面
            handleEdit: function (row) {
                this.editFormVisible = true
                if (row != undefined && row != 'undefined') {
                    this.title = '修改'
                    this.editForm = row
                    this.editForm.is_lock = row.is_lock.toString()
                } else {
                    this.title = '添加'
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        saveManager(this.editForm)
                            .then(res => {
                                this.editFormVisible = false
                                this.loading = false
                                if (res.success) {
                                    this.getdata(this.formInline)
                                    this.$message({
                                        type: 'success',
                                        message: '管理员保存成功！'
                                    })
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(err => {
                                this.editFormVisible = false
                                this.loading = false
                                this.$message.error('管理员保存失败，请稍后再试！')
                            })
                    } else {
                        return false
                    }
                })
            },
            // 删除权限
            deleteUser(index, row) {
                this.$confirm('确定要删除吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        ermissionDelete(row.permissionId)
                            .then(res => {
                                if (res.success) {
                                    this.$message({
                                        type: 'success',
                                        message: '管理员管理已删除！'
                                    })
                                    this.getdata(this.formInline)
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: res.msg
                                    })
                                }
                            })
                            .catch(err => {
                                this.loading = false
                                this.$message.error('管理员删除失败,请稍后再试！')
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            // 选择复选框事件
            selectChange(val) {
                this.selectdata = val
            },
            // 配置权限
            RolePermission() {
                let parms = {
                    roleId: '',
                    permissionIds: ''
                }
                if (this.formInline.roleId == '0') {
                    this.$message({
                        type: 'info',
                        message: '请选择角色'
                    })
                    return false
                }
                parms.roleId = this.formInline.roleId
                let len = this.selectdata
                let ids = []
                if (len != 0) {
                    for (let i = 0; i < len.length; i++) {
                        ids.push(len[i].permissionId)
                    }
                }
                parms.permissionIds = ids.join(',')
                RolePermission(parms)
                    .then(res => {
                        if (res.success) {
                            this.$message({
                                type: 'success',
                                message: '配置权限成功！'
                            })
                            this.getdata(this.formInline)
                        } else {
                            this.$message({
                                type: 'info',
                                message: res.msg
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('配置权限失败,请稍后再试！')
                    })
            },
            // 关闭编辑、增加弹出框
            closeDialog() {
                this.editFormVisible = false
            }
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/views/auth/manager.vue